import { api } from "@shared/api/client";
import type {
  CalidadControlModificacion,
  CalidadControlModificacionPayload,
} from "../../../types/control-modificaciones";
import type {
  CalidadPlanificacionDeCambio,
  CalidadPlanificacionDeCambioPayload,
  CalidadPlanificacionDeCambiosFilters,
  CalidadPlanificacionDeCambiosResponse,
} from "../types/planificacion-de-cambios";

function buildParams(filters: CalidadPlanificacionDeCambiosFilters) {
  return {
    search: filters.search || undefined,
    estado: filters.estado || undefined,
    fecha_desde: filters.fecha_desde || undefined,
    fecha_hasta: filters.fecha_hasta || undefined,
  };
}

export async function getCalidadPlanificacionDeCambios(
  filters: CalidadPlanificacionDeCambiosFilters,
  signal?: AbortSignal,
) {
  const { data } = await api.get<CalidadPlanificacionDeCambiosResponse>(
    "/certificaciones/iso-9001-14001/planificacion-de-cambios",
    { params: buildParams(filters), signal },
  );

  return data;
}

export async function createCalidadPlanificacionDeCambio(
  payload: CalidadPlanificacionDeCambioPayload,
) {
  const { data } = await api.post<{
    ok: boolean;
    data: CalidadPlanificacionDeCambio;
  }>("/certificaciones/iso-9001-14001/planificacion-de-cambios", payload);

  return data.data;
}

export async function updateCalidadPlanificacionDeCambio(
  id: number,
  payload: CalidadPlanificacionDeCambioPayload,
) {
  const { data } = await api.put<{
    ok: boolean;
    data: CalidadPlanificacionDeCambio;
  }>(`/certificaciones/iso-9001-14001/planificacion-de-cambios/${id}`, payload);

  return data.data;
}

export async function deleteCalidadPlanificacionDeCambio(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/planificacion-de-cambios/${id}`);
}

export async function createCalidadPlanificacionCambioControlModificacion(
  payload: CalidadControlModificacionPayload,
) {
  const { data } = await api.post<{
    ok: boolean;
    data: CalidadControlModificacion;
  }>("/certificaciones/iso-9001-14001/planificacion-de-cambios/control-modificaciones", payload);

  return data.data;
}

export async function updateCalidadPlanificacionCambioControlModificacion(
  id: number,
  payload: CalidadControlModificacionPayload,
) {
  const { data } = await api.put<{
    ok: boolean;
    data: CalidadControlModificacion;
  }>(`/certificaciones/iso-9001-14001/planificacion-de-cambios/control-modificaciones/${id}`, payload);

  return data.data;
}

export async function deleteCalidadPlanificacionCambioControlModificacion(id: number) {
  await api.delete(`/certificaciones/iso-9001-14001/planificacion-de-cambios/control-modificaciones/${id}`);
}
